import { useEffect, useState } from 'react';
import { api, TimbaPrediction } from '../api/client';
import { getIdentity } from './identity';

// Carga (una vez) los pronósticos del dispositivo y los devuelve indexados por nº de partido.
// Pensado para anotar la lista de partidos sin pedir un request por card.
export function useMyPredictions(): Map<number, TimbaPrediction> {
  const [map, setMap] = useState<Map<number, TimbaPrediction>>(new Map());

  useEffect(() => {
    let pub = '';
    try {
      pub = getIdentity().pub;
    } catch {
      return;
    }
    if (!pub) return;
    let alive = true;
    api
      .timbaPredictions(pub)
      .then((d) => {
        if (alive) setMap(new Map(d.predictions.map((p) => [p.num, p])));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return map;
}
